import { createGenericDispatcher } from '../../../action/action-dispatcher-factory';

import * as Api from '../../../api/api';

export const deleteSurvey = (surveyId: number) =>
  createGenericDispatcher<Survey>({
    name: 'DELETE_SURVEY',
    loadFunction: () => Api.del(`/surveys/${surveyId}`),
    args: { surveyId },
  });
